import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Breadcrumb, ProductSearchPage, ProductSearchService, RoutingService } from '@spartacus/core'
import { combineLatest, Observable, Subscription } from 'rxjs'
import { ProductListComponentService, ViewConfig, ViewModes } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { UrlUtils } from '../../../shared/utils/url-utils'
import { SearchUtilsService } from '../../services/search-utils.service'
import { Page } from 'smartsearch.js'
import { SmartSearchService } from '../../../cms/services/cms-search/smart-search.service'
import { MbSpinnerService } from '../../../shared/services/mb-spinner.service'
import { FilterProductsService } from '../../../product/services/filter-products.service'
import { debounceTime, filter, map, tap } from 'rxjs/operators'
import { customViewConfig } from '../../config/custom-view-config'

@Component({
  selector: 'mb-search-results',
  templateUrl: './mb-search-results.component.html',
  styleUrls: ['./mb-search-results.component.scss']
})
export class MbSearchResultsComponent implements OnInit, OnDestroy {

  #isCategoryPageFlag: boolean = false

  @Input()
  set isCategoryPage (isCategoryPage: boolean) {
    this.#isCategoryPageFlag = isCategoryPage
    this.searchUtilsService.shrinkLinesForCategoryPage(isCategoryPage)
  }

  get isCategoryPage () {
    return this.#isCategoryPageFlag
  }

  @Input()
  activeFacetsList: Breadcrumb[] | undefined

  @Input()
  readOnlyFacets: Breadcrumb[] | undefined

  subscription = new Subscription()
  model$: Observable<ProductSearchPage | undefined> | undefined
  cmsModel$: Observable<Page | undefined> | undefined
  viewMode = ViewModes.List
  showContentTab = false
  query = ''
  isProductLoaded = false
  isContentLoaded = false
  isFilterChanged = false

  constructor (private productListComponentService: ProductListComponentService,
               private smartSearchService: SmartSearchService,
               public scrollConfig: ViewConfig,
               private router: Router,
               private cdRef: ChangeDetectorRef,
               private searchUtilsService: SearchUtilsService,
               private productSearchService: ProductSearchService,
               private mbSpinnerService: MbSpinnerService,
               private filterProductService: FilterProductsService,
               private routingService: RoutingService) {
    this.scrollConfig = customViewConfig
  }

  ngOnInit () {
    this.subscription.add(this.routingService.getRouterState().subscribe((state: any) => {
        const query = (state?.state?.params?.['query'] || state?.state?.queryParams?.['query'] || '')?.trim()
        if (this.query.toLowerCase() !== query.toLowerCase()) {
          this.isProductLoaded = false
          this.isContentLoaded = false
        } else {
          this.isFilterChanged = true
        }
        this.query = query
      })
    )

    this.model$ = this.productListComponentService.model$.pipe(
      filter(model => (model?.freeTextSearch || '').toLowerCase().startsWith(this.query.toLowerCase())),
      map(model => {
        if (model?.keywordRedirectUrl) {
          this.mbSpinnerService.clearMbSpinner()
          this.filterProductService.clearAllData()
          this.productSearchService.clearResults()
          this.router.navigate([UrlUtils.getPath(model?.keywordRedirectUrl)?.toLowerCase()],
            { fragment: UrlUtils.getFragment(model?.keywordRedirectUrl)?.toLowerCase() })
          return undefined
        } else if (model?.freeTextSearch?.length || model?.currentQuery?.query?.value?.length || this.isCategoryPage) {
          this.isProductLoaded = model?.freeTextSearch?.toLowerCase() === this.query.toLowerCase() || model?.currentQuery?.query?.value?.toLowerCase() === this.query.toLowerCase()
          this.productSearchService.clearResults()
          return model
        }
        return undefined
      })
    )

    this.cmsModel$ = this.smartSearchService.model$.pipe(
      tap((model) => {
        // @ts-ignore
        const cmsQuery = model?.responseData?.requestParameters?.query?.[0]
        this.isContentLoaded = !!cmsQuery && cmsQuery.toLowerCase() === this.query.toLowerCase()
      })
    )

    this.subscription.add(combineLatest([this.productListComponentService.model$, this.smartSearchService.model$]).pipe(
      debounceTime(1000)
    ).subscribe(([model, cmsModel]) => {
        if ((this.isProductLoaded || model?.pagination?.totalResults === 0) &&
          (this.isContentLoaded || cmsModel?.numberOfResults === 0) ||
          (this.isFilterChanged && this.isProductLoaded)) {
          this.mbSpinnerService.clearMbSpinner()
          this.isFilterChanged = false
          this.isProductLoaded = false
          this.isContentLoaded = false
        }
      }))
  }

  ngOnDestroy () {
    this.smartSearchService.showContentTab.next(false)
    this.subscription?.unsubscribe()
  }

  showContent (flag: boolean) {
    this.showContentTab = flag
    this.smartSearchService.setShowContentTab(flag)
  }
}
